<!-- AI Generated Template -->
<div id="pages-with-duplicate-title" class="seo-dialog-pages-with-duplicate-title">
    <div class="mon-dialog-header">
        <page-header [header]="issue.name | translateSeoIssue"
                     [subHeader]="(titles.total || 0) + ' ' + ('Issues found' | translate)">
            <page-header-content>
                <div class="d-flex justify-content-end mon-dialog-delay-fadein">
                    <div class="p-1">
                        <csv-export-button
                                [exports]="exports"
                                clsSize="py-2 px-3"
                                clsMargin="mr-0">
                        </csv-export-button>
                    </div>
                </div>
            </page-header-content>
        </page-header>
    </div>

    <div class="mon-dialog-body bg-white">
        <div class="d-flex flex-column max-height">
            <quick-help-compliance-status [type]="'seo'"
                                          class="block bg-light-grey"
                                          *ngIf="shouldShowQuickHelp()"
                                          [data]="issue"
                                          [totalPagesCount]="pageCount"
                                          [totalPageIssues]="issue.pages_count">
            </quick-help-compliance-status>
            <div class="row flex-grow-1 d-flex flex-wrap align-items-stretch">
                <div class="col-48 col-md-24 pr-md-0 pages-with-duplicate-titles-titles-table">
                    <pages-with-duplicate-title-titles [titles]="titles"
                                                       [selectedTitle]="selectedTitle"
                                                       (onPageChange)="onPageChange($event)"
                                                       (onPerPageChange)="onPageSizeChange($event)"
                                                       (onSortPage)="onMonTableSort($event)"
                                                       (selectedTitleChange)="onSelectedTitleChange($event)"
                                                       [currentSort]="currentSort"
                                                       [promise]="promise">
                    </pages-with-duplicate-title-titles>
                </div>
                <div class="col-48 col-md-24 pl-lg-0 information-shadow pages-with-duplicate-titles-pages-table bg-light-grey">
                    <pages-with-duplicate-title-pages [selectedTitle]="selectedTitle"
                                                      (getTitles)="getTitles()"
                                                      [issue]="issue">
                    </pages-with-duplicate-title-pages>
                </div>
            </div>
        </div>
    </div>
</div>
